<template>
	<div v-if="visible">
		<el-dialog class="close-private-check"
							 :visible.sync="visible"
							 :title="$t('listPage.text.reInstallSystem')"
							 :close-on-click-modal="false"
							 :before-close="handleClose">
			<div class="i-text">
				<div class="tip-warning mb20" style="line-height: 19px"
						 v-html="$t('privateNetInstance.reInstallTip1')">
				</div>
			</div>
			<el-checkbox v-model="reinstallConfirmChecked" class="reinstall-confirm-checkbox"
									>
				{{$t('privateNetInstance.reinstallCheck')}}
			</el-checkbox>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelSys">{{ $t('privateNetInstance.cancel') }}</el-button>
				<el-button @click="sureSys" type="primary"
									 :disabled="secondReinstallConfirmDisabled">
					{{$t('privateNetInstance.sure')}}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>

	export default {
		name: 'reinstallSystemConfirm',
		props: {
		visible: {
			type: Boolean,
			default: false
		},
		rowInfo: {
			type: Object,
			default: () => {}
		},
		vpcNotChange: {
			type: Boolean,
			default: false
		},
		subnetNotChange: {
			type: Boolean,
			default: false
		},
		networkNameTag:{
			type: String,
			default: 'eth0'
		},
		clickToDetail: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			// 是否勾选了二次确认的checkbox
			reinstallConfirmChecked: false,
		};
	},
	computed: {
		secondReinstallConfirmDisabled: function() {
			// 第一次勾选格式化数据，第二次没有同意
			return !this.reinstallConfirmChecked
		}
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false);
		},
		cancelSys() {
			this.handleClose();
		},
		sureSys() {
			this.systemReinstallTwiceConfirm();
		},
		systemReinstallTwiceConfirm() {
			//let arr = encodeURIComponent(JSON.stringify(this.rowInfo))
			this.$router.push({
				path: '/instance/vpc/reinstall',
				name:'ReinstallSystem',
				query: {
					region: this.rowInfo.region,
					az: this.rowInfo.az,
					instanceId: this.rowInfo.instanceId,
					deviceType:this.rowInfo.deviceType,
					clickToDetail: this.clickToDetail,
				}
	        });
		},
	}
};
</script>

<style lang="scss">
	.close-private-check {
		.reinstall-confirm-checkbox{
			margin-bottom: -20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/privateNetInstance/reinstallSystem/reinstallSystemConfirm.vue